import { CompanySettings } from '../interfaces/companySettings';
import { companySettingsSlice } from '../reducers/companySettingsSlice';
import { getStore } from '../store';

type companySettingsType =
  | 'companySettings/setCompanySettings'
  | 'companySettings/setCompanyLogoUrl'
  | 'companySettings/setCompanyBranding';

export const companySettingsProvider = (): {
  setCompanySettings: (companySettings: CompanySettings) => { payload: CompanySettings; type: companySettingsType };
  setCompanyLogoUrl: (logo: string) => { payload: string; type: companySettingsType };
  setCompanyBranding: (branding: string) => { payload: string; type: companySettingsType };
} => {
  const { dispatch } = getStore();
  const { setCompanySettings, setCompanyLogoUrl, setCompanyBranding } = companySettingsSlice.actions;
  return {
    setCompanySettings: (companySettings: CompanySettings): { payload: CompanySettings; type: companySettingsType } =>
      dispatch(setCompanySettings(companySettings)),

    setCompanyLogoUrl: (logo: string): { payload: string; type: companySettingsType } =>
      dispatch(setCompanyLogoUrl(logo)),

    setCompanyBranding: (branding: string): { payload: string; type: companySettingsType } =>
      dispatch(setCompanyBranding(branding)),
  };
};
